// Site header — two stacked variants:
//   - .header        — full header, visible while at the top of the page
//   - .header--compact — slim scroll-up bar, visible when the user has
//                        scrolled past the threshold AND is scrolling UP
//
// Scroll DOWN → both hidden. Scroll UP (past threshold) → compact shows,
// full stays hidden. At/near the top → full shows, compact hides.
//
// Also re-reveals the appropriate variant when the mouse moves upward
// into the top 200px of the viewport on desktop.

const THRESHOLD = 80           // px scrolled before we start swapping
const DELTA = 6                // min px scroll delta per tick to flip state
const MOUSE_REVEAL_ZONE = 200  // top band (px) where mouse-upward reveals header
const DESKTOP_MIN_WIDTH = 750  // matches $breakpoint-small

const siteHeader = {
    init() {
        const fullHeader = document.querySelector('[data-site-header]')
        const compactHeader = document.querySelector('[data-site-header-compact]')
        if (!fullHeader) return

        let lastY = window.scrollY || 0
        let lastMouseY = null
        let ticking = false

        const showFull = () => {
            fullHeader.classList.remove('is-hidden')
            if (compactHeader) compactHeader.classList.remove('is-active')
        }

        const showCompact = () => {
            fullHeader.classList.add('is-hidden')
            if (compactHeader) compactHeader.classList.add('is-active')
        }

        const hideBoth = () => {
            fullHeader.classList.add('is-hidden')
            if (compactHeader) compactHeader.classList.remove('is-active')
        }

        const update = () => {
            const y = window.scrollY || 0
            const diff = y - lastY

            if (Math.abs(diff) >= DELTA) {
                if (y <= THRESHOLD) {
                    // Near the top — always show the full header.
                    showFull()
                } else if (diff > 0) {
                    // Scrolling down past threshold — hide both.
                    hideBoth()
                } else if (diff < 0) {
                    // Scrolling up past threshold — show the compact bar.
                    showCompact()
                }
                lastY = y
            }

            ticking = false
        }

        window.addEventListener('scroll', () => {
            if (!ticking) {
                window.requestAnimationFrame(update)
                ticking = true
            }
        }, { passive: true })

        window.addEventListener('mousemove', (e) => {
            if (window.innerWidth < DESKTOP_MIN_WIDTH) return
            const y = e.clientY
            const movingUp = lastMouseY !== null && y < lastMouseY
            lastMouseY = y
            if (y <= MOUSE_REVEAL_ZONE && movingUp) {
                // Mirror the scroll-up behavior: full at the top, otherwise compact.
                if ((window.scrollY || 0) <= THRESHOLD) showFull()
                else showCompact()
            }
        }, { passive: true })
    }
}

export default siteHeader
